import { Box, Grid, Stack, Typography } from '@mui/material';
import { CardSection } from '../../shared/components/card/CardSection';

export const PlansHelp: React.FC = () => {
  return (
    <Box>
      <CardSection
      title={
              <Stack
                direction={'row'}
                width={'100%'}
                alignItems={'center'}
                justifyContent={'space-between'}
                sx={{ py: '15px' }}>
                <Box>
                  <Typography fontSize={{ sx: '16px', md: '20px' }} fontWeight={600}>
                    Información importante
                  </Typography>
                </Box>
              </Stack>
            }>
        
        <Grid
          rowGap={'16px'}
          borderRadius={'15px'}
          paddingTop={'16px'}
        >
          <Typography fontSize={{ sx: '16px', md: '18px' }} fontWeight={700}>
            En referencia a la actualizacion de planes:
          </Typography>
          <ul>
            <li style={{ paddingBottom: '8px' }}>
              <Typography>
                Para que un usuario pueda cambiar su plan a uno más económico o con menos
                beneficios, se debe:
              </Typography>
              <ol style={{ paddingTop: '6px' }}>
                <li style={{ paddingBottom: '6px' }}>
                  <Typography>
                    Cancelar manualmente el plan y esperar a que finalice su período vigente.
                  </Typography>
                </li>
                <li style={{ paddingBottom: '6px' }}>
                  <Typography>
                    Solicitar la desactivación inmediata de la suscripción (con ayuda de un
                    operador) y luego adquirir el nuevo plan deseado.
                  </Typography>
                </li>
              </ol>
            </li>
            <li style={{ paddingBottom: '8px' }}>
              <Typography>
                Cuando un usuario actualiza a un plan superior con los mismos beneficios (por
                ejemplo, al cambiar del plan estudiantil al mensual), el cambio se aplica
                inmediatamente, pero el nuevo cobro se realizará al finalizar el período actual.
              </Typography>
            </li>
            <li style={{ paddingBottom: '8px' }}>
              <Typography>
                Si el usuario actualiza a un plan con mayores beneficios (por ejemplo, al cambiar
                del plan estudiantil o mensual al anual), la suscripción se modificará de inmediato,
                cobrando la diferencia entre el plan ya pagado y el nuevo plan seleccionado. De esta
                forma, el usuario podrá disfrutar de los beneficios mejorados desde el día en que
                adquiere el nuevo plan.
              </Typography>
            </li>
            <li style={{ paddingBottom: '8px' }}>
              <Typography>
                La actualización de suscripción solo está disponible cuando el método de pago es
                Stripe, debido a las limitaciones técnicas de PayPal.
              </Typography>
            </li>
          </ul>
        </Grid>
      </CardSection>
    </Box>
  );
};
